export const roundedProgressPercentage = (progress: number, total: number) => progress === 0 ? 0 : Math.max(Math.floor(progress / total * 100), 1);